/** @jsx jsx */
import { jsx, Image } from 'theme-ui'
import Layout from '../components/layout'
import Headshot from '../images/react-screenshot.png'
import BTT from '../images/BTT_SC.png'
import BostonGlobe from '../images/boston-globe.jpg'
import SEO from '../components/seo'
import Sparkles from '../components/sparkles'

const About = () => {
  return (
    <Layout
      activeMenu="about"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <SEO title={'About'} />
      <div className="container">
        <Sparkles>
              <Image
                src={BostonGlobe}
                alt="Pariss holding boston globe news feature"
                sx={{
                  marginTop: '30px',
                  marginBottom: '30px',
                  maxWidth: '200px',
                }}
              />
            </Sparkles>
        <div className="intro">
          <h3>Welcome!</h3>
        </div>
        <div classname="bio" sx={{ marginTop: '30px' }}>
          <p>
            I'm Pariss Chandler, but I go by Pariss Athena. Creator of the hashtag, movement, and global community
            <a
              href="https://twitter.com/ParissAthena/status/1068873547005812737?s=20"
              sx={{
                color: 'primary',
                marginLeft: '2px',
                textDecoration: 'underline',
              }}
            >
              #BlackTechTwitter
            </a>
            , Founder and CEO of Black Tech Pipeline.
          </p>
        </div>
        <div className="bg-story" sx={{ marginTop: '30px' }}>
          <p>
            Some context: I'm an actress, turned Wax Specialist, turned Software
            Engineer. I learned to code and got my first job as a Software
            Engineer in 2017. In 2018, I was laid off from that job and on the
            hunt to find a new role. I decided to get onto Twitter to tweet
            about my journey finding a job in tech, and vent about the trials
            and tribulations of what it's like to be the only Black person at a
            company. A couple of months in, I discovered that there was a very
            small community of Black technologists, which was shocking because
            up until that point, I honestly believed there were just no Black
            people in tech. I never worked with someone who looked like me, and
            I rarely saw many Black people at conferences or meetups I'd attend.
            Out of shock and curiousity, I put out a tweet asking, 'What does
            Black Twitter in tech look like?'. I didn't expect anything to come
            from that tweet since I was so new to the Twitter platform and
            barely had a following, but the complete opposite happened. My phone
            began vibrating non-stop with responses to my tweet. Black
            technologists from all over the world were responding to the tweet,
            which created a super long thread of their selfies with captions of
            what they do in the industry. It was surreal, but that's the power
            of social media!
          </p>
          <p sx={{ marginTop: '30px' }}>
            Over night, we formed a movement, community and hashtag now known as
            #BlackTechTwitter. During this wild experience, employers,
            conference organizers, and opportunity extenders of all sorts were
            reaching out to me through Twitter to collaborate and recruit
            candidates out of the new #BlackTechTwitter community. Mind you, I
            had no recruiting experience, and this whole formation of a new
            community wasn't my intention, but I knew the impact it would have
            on our community to begin recruiting job seekers into these open
            opportunities, so I said 'yes' to everyone! I also did it for free.
            For the past year and a half, I've been conducting business straight
            out of my Twitter DM's. I've had the opportunity to recruit job
            candidates into many different companies, and passed along all sorts
            of opportunities to our community. While that sounds super cool and
            successful, there were still inclusivity and retention problems
            amongst some of the employers I was recruiting for, so I decided to
            build a business model that centered around the happiness of the
            candidates, and providing employers transparent feedback to create a
            better culture and improve retention.
          </p>
          <div sx={{ width: ['100%', '100%', '50%'] }}>
            <Sparkles>
              <Image
                src={BTT}
                alt="Screen shot of Pariss @ParissAthena tweeting 'What does black twitter in tech look like? Here, I'll go first'"
                sx={{ marginTop: '30px', width: '100%' }}
              />
            </Sparkles>
          </div>
        </div>
        <div className="past-bg" sx={{ marginTop: '30px' }}>
          <p>
            On every engineering team I've worked on, and at every company I've
            worked for, I wasn't <span sx={{ fontStyle: 'italic' }}>just</span>{' '}
            the only woman or Black person on the team, but the only Black
            person in the entire company. Before entering tech, I had jobs where
            I was always surrounded by co-workers who looked like me. Thinking
            about race, and being a 'culture fit' wasn't something that ever
            crossed my mind, nor was it brought up in interview processes. Once
            I entered tech, it consumed me. I dealt with exclusion, racism,
            bias, and being treated differently overall. I'd look around and see
            that my co-workers could easily build relationships with those who
            they felt they had things in common with, and appearance was a big
            commonality.
          </p>
          <p sx={{ marginTop: '30px' }}>
            The Black Tech Pipeline business model was inspired by the needs of
            our community members who are usually the minority in predominantly
            white work spaces. Any time someone is recruited and hired oiut of
            Black Tech Pipeline, I virtually stay on the job with them for the
            first 90 days. I do bi-weekly check-ins with BTP hires to get
            feedback on their experience thus far, and make sure they're in an
            environment that is setting them up for success. I relay that
            feedback to their manager and work with them on what that specific
            candidate needs to thrive in their role, and move up the ladder in
            the company. I also help these employers with their diversity,
            equity, and inclusion intiatives.
          </p>
          <p sx={{ marginTop: '30px' }}>
            Doing DEI work needs to be a priority at the foundation of every
            company, and in every industry, but especially tech. We're living in
            a digitally driven era, and the tech industry is where underserved
            communities are going to be left behind- mainly Black and Brown.
            Thankfully, #BlackTechTwitter helped debunk the excuse that there is
            a "pipeline problem." There isn't. There are skilled and qualified
            Black people already thriving in the tech industry.
          </p>
        </div>
        <div
          className="now-story"
          sx={{ marginTop: '30px', marginBottom: '30px' }}
        >
          <p>
            Wrapping up, I've had the privilege of running Black Tech Pipeline
            the way I see fit- with transparency and authenticity. My priority
            is the safety of our community members, being able to offer honest
            feedback to our partners, and holding this industry accountable.
          </p>
        </div>
        <div sx={{ marginTop: '30px', marginBottom: '30px' }}>
          <p>
            Read more about our community in our newsletter{' '}
            <a
              href="https://blacktechpipeline.substack.com/p/coming-soon"
              sx={{ color: 'primary', textDecoration: 'underline' }}
            >
              <span>here</span>
            </a>
            !
          </p>
          <p sx={{ marginTop: '30px' }}>
            Follow{' '}
            <a
              href="https://twitter.com/BotBlackTech"
              sx={{
                color: 'primary',
                textDecoration: 'underline',
                fontSize: '14px',
              }}
            >
              <span>@BotBlackTech</span>
            </a>
            , created by{' '}
            <a
              href="https://twitter.com/holycode5"
              sx={{
                color: 'primary',
                textDecoration: 'underline',
                fontSize: '14px',
              }}
            >
              <span>Kelli Davis</span>
            </a>
            , on Twitter and turn on notifications for all things
            #BlackTechTwitter!
          </p>
        </div>
        <div
          className="pariss-socials"
          sx={{ color: 'darkGrey', marginBottom: '50px' }}
        >
          <p sx={{ marginBottom: '10px', fontWeight: 'bold' }}>
            And you can always catch me here!
          </p>
          <span sx={{ fontSize: '14px' }}>
            Twitter:
            <a
              href="https://twitter.com/ParissAthena"
              sx={{
                color: 'primary',
                textDecoration: 'underline',
                fontSize: '14px',
              }}
            >
              {' '}
              @ParissAthena
            </a>
          </span>
          <div>
            <span sx={{ fontSize: '14px' }}>
              LinkedIn:
              <a
                href="https://www.linkedin.com/in/pariss-chandler/"
                sx={{
                  color: 'primary',
                  textDecoration: 'underline',
                  fontSize: '14px',
                }}
              >
                {' '}
                Pariss Chandler
              </a>
            </span>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default About
